module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticStyle: {
      "background": "url('../../../static/search/roomTopBg.png')",
      "background-repeat": "repeat-x",
      "max-width": "480px",
      "height": "0.7rem",
      "width": "100%",
      "position": "absolute",
      "z-index": "11"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin": "0.4rem 0.1rem 0.1rem 0.45rem",
      "height": "0.45rem",
      "position": "fixed",
      "z-index": "12"
    },
    attrs: {
      "src": require("../../../static/home/Brand/GoBack.png")
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }), _vm._v(" "), (_vm.IsShow) ? _c('swiper', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "options": _vm.swiperOption,
      "id": "BrandIntroduce"
    }
  }, [_c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _vm._l((_vm.PicBig), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "4.2rem"
      },
      attrs: {
        "src": _vm.PicSmall[index]
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "5%",
        "width": "90%",
        "text-align": "center"
      }
    }, [_c('div', {
      class: {
        'Color0': index == 0, 'Color4': index == 4, 'Color5': index == 5, 'Color6': index == 6,
          'Color7': index == 7, 'ColorBrown': index == 1 || index == 2 || index == 3, 'Color8': index == 8
      },
      staticStyle: {
        "margin-top": "-0.2rem",
        "font-size": "0.34rem",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.HotelShort[index]))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "0.4rem 0 0.1rem 0%",
        "color": "#333333",
        "font-size": "0.26rem",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(_vm.HotelLong[index]))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.3rem"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "92%",
        "overflow": "hidden",
        "margin": "auto"
      }
    }, [_c('div', [_c('div', {
      staticClass: "SiGeKuang0223",
      on: {
        "click": function($event) {
          return _vm.GoOtherPage(_vm.HotelDescrib[index], index)
        }
      }
    }, [_c('img', {
      staticStyle: {},
      attrs: {
        "src": require("../../../static/home/Brand/Entrance6.png")
      }
    }), _vm._v(" "), _c('div', [_vm._v("品牌展示")])]), _vm._v(" "), _c('div', {
      staticClass: "SiGeKuang0223_Split"
    }), _vm._v(" "), _c('div', {
      staticClass: "SiGeKuang0223",
      on: {
        "click": function($event) {
          return _vm.GoOtherPage(_vm.HotelScenery[index], index)
        }
      }
    }, [_c('img', {
      staticStyle: {},
      attrs: {
        "src": require("../../../static/home/Brand/Entrance5.png")
      }
    }), _vm._v(" "), _c('div', [_vm._v("全景展示")])]), _vm._v(" "), _c('div', {
      staticClass: "SiGeKuang0223_Split"
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.PostPdfurl(index)
        }
      }
    }, [_c('div', {
      staticClass: "SiGeKuang0223"
    }, [_c('img', {
      attrs: {
        "src": require("../../../static/home/Brand/Entrance7.png")
      }
    }), _vm._v(" "), _c('div', [_vm._v("加盟手册")])])]), _vm._v(" "), _c('div', {
      staticClass: "SiGeKuang0223_Split"
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.PostPdfurl(9)
        }
      }
    }, [_c('div', {
      staticClass: "SiGeKuang0223"
    }, [_c('img', {
      attrs: {
        "src": require("../../../static/home/Brand/Entrance8.png")
      }
    }), _vm._v(" "), _c('div', [_vm._v("投资手册")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.6rem"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "BGColor3",
      staticStyle: {
        "color": "white",
        "font-size": "0.36rem",
        "border-radius": "0.08rem",
        "line-height": "1rem",
        "z-index": "99123"
      },
      on: {
        "click": function($event) {
          return _vm.GoHotelList(index)
        }
      }
    }, [_vm._v("搜索" + _vm._s(_vm.HotelName[index]) + "酒店")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    staticStyle: {
      "margin-bottom": "3.1rem"
    },
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-522be216!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/BrandIntroduce.vue
// module id = 1506
// module chunks = 18